(function () {
    const collapsers = document.querySelectorAll('[data-bs-toggle="collapse"]');
    if (collapsers) {
        collapsers.forEach((element) => {
            const target = element.dataset.bsTarget;
            element.onclick = function (e) {
                e.preventDefault();
                const expanded = element.getAttribute("aria-expanded") == "true";
                targetElement = document.getElementById(target.substring(1));
                //console.log(expanded, "clicked", target.substring(1), targetElement);

                if (!expanded) {
                    targetElement.classList.add("show");
                    element.setAttribute("aria-expanded", "true");
                } else {
                    targetElement.classList.remove("show");
                    element.setAttribute("aria-expanded", "false");
                }
            }
        })
    }


})();